import type { ReactElement } from 'react';

const HOW_IT_WORKS_STEPS = [
  {
    step: '1',
    title: 'Pick your games',
    desc: "Select tonight's NBA matchups and prop markets you want analyzed",
  },
  {
    step: '2',
    title: 'Get AI analysis',
    desc: 'Our models score every prop using live lines, stats, and matchup context',
  },
  {
    step: '3',
    title: 'Track & improve',
    desc: 'Build parlays, track results live, and refine your strategy over time',
  },
] as const;

export function HowItWorksSection(): ReactElement {
  return (
    <>
      <div className="mt-16 pt-12 border-t border-theme-border/30">
        <h3 className="text-center text-xl font-bold text-white mb-8">How it works</h3>
        <div className="grid sm:grid-cols-3 gap-8">
          {HOW_IT_WORKS_STEPS.map((item) => (
            <div key={item.step} className="text-center">
              <div className="w-10 h-10 rounded-full bg-theme-primary/15 text-theme-primary font-bold text-lg flex items-center justify-center mx-auto mb-3">
                {item.step}
              </div>
              <h4 className="font-semibold text-white mb-1">{item.title}</h4>
              <p className="text-sm text-theme-text-tertiary">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="text-center mt-12">
        <a
          href="/faq"
          className="text-theme-primary hover:text-theme-primary-hover text-sm transition-colors inline-flex items-center gap-1"
        >
          Have questions? Read our FAQ &amp; Guides {'→'}
        </a>
      </div>
    </>
  );
}
